// ////////////////////////////////////////////////////////////////////////////////
// Fichier pour la gestion du bandeau VB + cookies
// ////////////////////////////////////////////////////////////////////////////////
// Creation : 30/05/2022 CGR
// ////////////////////////////////////////////////////////////////////////////////



// //////////////////////////////////
// Imports

// Imports system
import React, { useContext } from "react";
import { programmeContext } from './../../contexts';

// Bouton
const Credits = () => {
    const programmeDatas = useContext(programmeContext);
    const logoSrc = programmeDatas.poweredBylogoName;
    const logoLink = programmeDatas.poweredByUrlName;

    if (!logoSrc || !logoLink) {
        return null;
    }

    return (
        <a id='credits' href={logoLink}>
            <p>powered by</p>
            <img src={logoSrc} alt="Logo"></img>
        </a>

    )
}

export default Credits;